import React from 'react';

import {store} from './app/store';
import App from './App';
import ErrorBoundary from './ErrorBoundary';

import {createRoot} from 'react-dom/client';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import {install} from 'resize-observer';

// Polyfill for older browsers that don’t support ResizeObserver!
if (!window.ResizeObserver) install();

const container = document.getElementById('root');
// tslint:disable-next-line:no-non-null-assertion
const root = createRoot(container!);

root.render(
    <Provider store={store}>
        <BrowserRouter>
            <ErrorBoundary>
                <App />
            </ErrorBoundary>
        </BrowserRouter>
    </Provider>,
);
